import { api } from "../../api/axios";
import type { TUpdateProgressRequest } from "../types";

/**
 * Update lesson viewing progress
 * @param lessonId - The unique identifier of the lesson
 * @param lastVideoViewSec - The last viewed second of the video
 * @returns Promise with the updated progress data
 */
export const updateLessonProgress = async (
  lessonId: number,
  lastVideoViewSec: number
): Promise<TUpdateProgressRequest["response"]> => {
  const response = await api.put<TUpdateProgressRequest["response"]>(
    `/v1/users/me/lessons/${lessonId}/progress`,
    {
      lastVideoViewSec: Math.floor(lastVideoViewSec), // Ensure it's an integer
    }
  );
  return response.data;
};
